import type { LinkingOptions } from '@react-navigation/native';

import type { RootStackParamList } from '../types/navigation';

/**
 * Maps each screen to a URL path so every screen has its own indexable URL on
 * the web build.
 *
 * Keep these paths in sync with:
 *   - the sitemap URL list in web/webpack.config.js (EmitSeoAssetsPlugin);
 *   - the <noscript> links in web/index.html.
 *
 * The paths deliberately avoid the app's own API route names (`/stations`,
 * `/news`, `/guide`, `/affiliation`) which live on the same production
 * origin: a direct browser visit to `/akhbar` must return the HTML shell,
 * not API JSON.
 */
export const linking: LinkingOptions<RootStackParamList> = {
  // On web the current browser URL is used directly (pathname + search), so
  // no URL prefixes need to be matched.
  prefixes: [],
  config: {
    screens: {
      Map: '',
      News: 'akhbar',
      Guides: 'rahnama',
    },
  },
};
